module.exports = __webpack_public_path__ + "images/avatars/female/6.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/6.svg
// module id = DDR7
// module chunks = 153